import { Wrapper, Link } from './styled';
import WatchlistSolid from '@simplywallst/ui-core/icons/WatchlistSolid';
import StocksSolid from '@simplywallst/ui-core/icons/StocksSolid';
import DiscoverSolid from '@simplywallst/ui-core/icons/DiscoverSolid';
import {
  ROUTE_MARKET,
  ROUTE_STOCKS_MARKET,
  ROUTE_DISCOVER_INVESTING_IDEAS,
  ROUTE_MARKET_HOME,
} from '@/constants/routes';
import type { PrimaryCountryISOElseGlobal } from '@/constants/countries';

import type { SortBy } from '@/pages/Stocks/hooks/useSortByOptions';
import { useTracking } from 'react-tracking';

type Props = {
  market: PrimaryCountryISOElseGlobal;
  country: string;
};

const EndState = ({ market, country }: Props) => {
  const { trackEvent } = useTracking();
  const trackingConfig = {
    type: 'track' as const,
    subject: 'end state',
    action: 'click',
  };
  return (
    <Wrapper
      data-cy-id="end-state"
      rowGap="16px"
      columnGapMd="24px"
      templateColumnsMd="1fr 1fr 1fr"
    >
      <Link
        noUnderline
        to={{
          type: ROUTE_STOCKS_MARKET,
          payload: { market, sortBy: 'market-cap-large' as SortBy },
        }}
        onClick={() => {
          trackEvent({
            ...trackingConfig,
            modifier: 'view stocks',
          });
        }}
      >
        <WatchlistSolid />
        <div>View all stocks in the {country} market</div>
      </Link>
      <Link
        noUnderline
        to={{
          type: market === 'global' ? ROUTE_MARKET_HOME : ROUTE_MARKET,
          payload: { market },
        }}
        onClick={() => {
          trackEvent({
            ...trackingConfig,
            modifier: 'view Market',
          });
        }}
      >
        <StocksSolid />
        <div>{country} Market Valuation and Analysis</div>
      </Link>
      <Link
        noUnderline
        to={{ type: ROUTE_DISCOVER_INVESTING_IDEAS }}
        onClick={() => {
          trackEvent({
            ...trackingConfig,
            modifier: 'view ideas',
          });
        }}
      >
        <DiscoverSolid />
        <div>Explore other investing ideas for the {country} market</div>
      </Link>
    </Wrapper>
  );
};

export default EndState;
